export const UPDATE_TOKEN = 'updateToken';
export const UPDATE_PCTOKEN = 'updatePcToken';
export const UPDATE_USER_STATUS_ASYNC = 'checkUserStatus';
export const UPDATE_USER_BRIEF = 'updateUserBrief';
export const UPDATE_PROVIDERID = 'updateProviderId';
export const UPDATE_USER_BRIEF_ASYNC = 'getUserBriefAsync';
export const UPDATE_USER_PHONE = 'updateUserPhone';
export const UPDATE_USER_COMPANYNAME = 'updateUserCompanyName';
export const UPDATE_TEMPTOKEN = 'updateTempToken';
export const UPDATE_MENU_CONFIG = 'updateMenuConfig';
export const UPDATE_SEALNAME = 'updateSealName';
export const UPDATE_RESIGTER_STEP = 'updateResigterStep';
export const UPDATE_COMPANY_ID = 'updateCompanyId';
export const UPDATE_COMPLETE_INITIAL_SET = 'getInitialSet';
export const UPDATE_COMPLETE_INIT = 'updateCompleteStatus';
export const UPDATE_SOCKET_MESSAGE = 'socketMessage/updateSocketMessage';
export const UPDATE_NON_USER = 'updateNonUser';
export const UPDATE_SUPPLIER_SHOW_SET_PAY_STATUS = 'updateSupplierShowSetPayStatus';
export const UPDATE_ENCRYPTION_ID = 'updateEncryptionId';
export const UPDATE_COMPANY_STATUS = 'updateCompanyStatus';
export const UPDATE_ALL_MENU_VISIBLE = 'updateAllMenuVisible';
export const UPDATE_MENU_VISIBLE = 'updateMenuVisible';
export const UPDATE_BUTTON_VISIBLE = 'updateButtonVisible';

export default {
  UPDATE_TOKEN,
  UPDATE_PCTOKEN,
  UPDATE_USER_STATUS_ASYNC,
  UPDATE_USER_BRIEF,
  UPDATE_USER_BRIEF_ASYNC,
  UPDATE_PROVIDERID,
  UPDATE_USER_PHONE,
  UPDATE_USER_COMPANYNAME,
  UPDATE_TEMPTOKEN,
  UPDATE_MENU_CONFIG,
  UPDATE_SEALNAME,
  UPDATE_RESIGTER_STEP,
  UPDATE_COMPANY_ID,
  UPDATE_COMPLETE_INITIAL_SET,
  UPDATE_COMPLETE_INIT,
  UPDATE_SOCKET_MESSAGE,
  UPDATE_NON_USER,
  UPDATE_SUPPLIER_SHOW_SET_PAY_STATUS,
  UPDATE_ENCRYPTION_ID,
  UPDATE_COMPANY_STATUS,
  UPDATE_ALL_MENU_VISIBLE,
  UPDATE_MENU_VISIBLE,
  UPDATE_BUTTON_VISIBLE
};
